import { Action } from "redux";
import { OrganizationKeyName } from "../../../model/Organization";

export const INSERT_VENUE_SUCCESS = "INSERT_VENUE_SUCCESS";

export interface InsertVenueSuccessAction extends Action {
  type: typeof INSERT_VENUE_SUCCESS;
  organization: OrganizationKeyName;
}

export const insertVenueSuccessAction = (
  organization: OrganizationKeyName
): InsertVenueSuccessAction => ({
  type: INSERT_VENUE_SUCCESS,
  organization,
});
